import { Box, Button } from "@mui/material";
import React, { FC, useRef, useState } from "react";
import CustomFields, { ICustomFieldsRef } from "../../../common/CustomFields";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { useRestartBackgroundJobsMutation } from "../../../redux/reducers/ots.reducer";
import { useAppDispatch } from "../../../redux";
import { showFeedbackNotification } from "../../../redux/reducers/notifications.reducer";

const CustomFieldsConfig: FC = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const customFieldsRef = useRef<ICustomFieldsRef>(null);

	const [showSaveButtonLoader, setShowSaveButtonLoader] = useState<boolean>(false);

	// APIS
	// RESTART BACKGROUND JOBS
	const [restartBackgroundJobs] = useRestartBackgroundJobsMutation();

	function handleBackButtonClick() {
		navigate(-1);
	}

	function handleSubmitButtonClick() {
		if (customFieldsRef.current) {
			setShowSaveButtonLoader(true);
			customFieldsRef.current.onSubmit();
		}
	}

	function handleSubmitCallback() {
		restartBackgroundJobs()
			.unwrap()
			.then(() => {
				navigate("/ots/add-camera");
			})
			.catch((error) => {
				dispatch(
					showFeedbackNotification({
						message: "data" in error && error.data ? String(error.data) : "Something went wrong",
						severity: "error"
					})
				);
			})
			.finally(() => {
				setShowSaveButtonLoader(false);
			});
	}

	function handleSubmitErrorCallback() {
		setShowSaveButtonLoader(false);
	}

	return (
		<Box className="ots-screen-content-wrapper">
			<Box className="ots-society-config-content-wrapper">
				<Box className="ots-society-config-tab-content">
					<CustomFields
						hideSubmitButtons
						ref={customFieldsRef}
						submitSuccessCallback={handleSubmitCallback}
						submitErrorCallback={handleSubmitErrorCallback}
					/>
				</Box>
			</Box>

			<Box className="ots-form-actions-wrapper">
				<Button variant="outlined" color="error" sx={{ paddingX: 5 }} onClick={handleBackButtonClick}>
					Back
				</Button>

				<LoadingButton
					disableElevation
					variant="contained"
					color="primary"
					onClick={handleSubmitButtonClick}
					loading={showSaveButtonLoader}
					endIcon={<ArrowRightIcon />}
				>
					Next
				</LoadingButton>
			</Box>
		</Box>
	);
};

export default CustomFieldsConfig;
